import styled from "styled-components";

export const Tooltip = styled.div`
  position: absolute;
  top: 28%;
  left: 50%;
  transform: translate(-50%, 100%);
  background-color: #595959;
  border-radius: 3px;
  text-align: center;
  padding: 4px 20px;
  min-width: 120px;
  max-width: 180px;
  color: #ffffff;
  font-size: 11px;
  letter-spacing: 0.4px;
  font-weight: 400;
  opacity: 0;
  pointer-events: none;
  z-index: 99;
  white-space: nowrap;
`;

export const ExtendedWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0;

  div:first-child {
    input {
      border-radius: 3px 0 0 3px;
    }
  }

  div:last-child {
    input {
      border-radius: 0 3px 3px 0;
      border-right: 1px solid #ebebeb;
    }
  }
`;

export const BoxInputs = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  :hover {
    ${Tooltip} {
      opacity: 1;
      transition: 0.2s opacity 0.3s cubic-bezier(0.55, 0.3, 0.5, 0.9);
    }
  }
`;

export const InputRadius = styled.input`
  width: 60px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ebebeb;
  text-align: center;
  border-right: none;

  &:focus {
    outline: 1px solid #44ADF8;
    outline-offset: -1px;
  }

  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
